<template>
  <div class="about" style="background:#fff;">
    <Banner image="guitarra-2" />
    <header data-aos="zoom-in" data-aos-delay="30">
      <h1 class="display-1">Acerca de mi</h1>
      <p class="subtitle-1">No hay mucho que decir</p>
    </header>
    <main>
      <div class="content-img" data-aos="fade-up" data-aos-delay="1000">
        <img :src="require('@/assets/images/foto-guitarra.jpg')" alt="">
      </div>
      <div class="content-text">
        <p data-aos="fade-up" data-aos-delay="1000">soy imprudente al psar la pista<br>como el panetón con la mano<br>Me pongo las medias al revés<br>imagino palabras todo el tiempo<br>y canto por la calle todo el tiempo<br>odio la sopa caliente en verano<br>y en invierno también<br>el olor a figuras nuevas<br>tomar de vez en cuando un buen licor<br>Detesto la impuntualidad<br>y venero el desorden<br>Me gusta caminar por ese murito de las veredas<br>Y besar la frente de mi madre<br>Pero sobre todo me gustan las cosas simples<br>Evitar las colas<br>Gritar de alegría<br>y callarme si puedo herir a alguien<br>Cantar en inglés sin tener ni puta idea<br>y salir corriendo sin saber a donde</p>
        <span data-aos="zoom-in" data-aos-delay="1000">"No pido demasiado, pido todo. Y "todo" nunca es mucho cuando hay ganas"</span>
        <p data-aos="fade-up" data-aos-delay="1000">Me gustan esas pequeñas cosas que te da la vida pero por sobré todo<br>- aquí diría que me gustas tú-<br>Me gustaría invitarte a compartirlo<br>que tú me compartas tu lista de gustos y disgustos (por así decirlo)<br>Y construyamos algo<br>No sé<br>ALGO<br>como de mampostería .</p>
      </div>
    </main>
  </div>
</template>

<script>
  import Banner from '@/components/BannerBlog';
  export default {
    name:'about',
    components:{Banner}
  }
</script>

<style lang="scss" scoped>
header{
  text-align: center;
  margin: 3rem 0;
}
main{
  text-align: center;
}
.content-img{
  & img {
    width: auto;
    border-radius: 10px;
    @media screen and (max-width:600px){ 
    width: 350px;
  }
  }
}
.content-text{
  margin-top:2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  & p{
    width: 50%;
    margin:1rem 0 ;
    // text-align: left;
    @media screen and (max-width:600px){ 
    width: 100%;
  }
  }
  & span{
    width: 50%;
    background: #8C634A;
    color: #fff;
    padding: 1.5rem 0;
    border-radius: 4px;
    margin: 1rem 0;
    @media screen and (max-width:600px){ 
      width: 100%;
    }
  }
}
[data-aos=fade-up]{
  @media screen and (max-width:900px){
    transform:none;
  }
  
  }
[data-aos=zoom-in]{
  @media screen and (max-width:900px){
  transform:none;
  }
  
  }

</style>
<style lang="scss">
body[data-aos-delay='1000'] [data-aos], [data-aos][data-aos][data-aos-delay='1000']{
  @media screen and (max-width:900px){
    transition: delay 0s !important;
  transition-duration:0s !important;
  }  
  }
</style>